import { FREE_CARD_LIMIT, FREE_CARD_LIMIT_WARNINGS } from 'lib/constants';

class UpsellUI {
  constructor({ user }) {
    this.user = user;
    if (this.user) {
      this.nodeCount = this.user.nodeCount;
    }
  }

  setCanvas(canvas) {
    this.canvas = canvas;
    this.operation = canvas.operation;
    this.dismissedUpsellBanners = [];

    this.operation.on('node-count-change', message => {
      this.updateNodeCount(message.nodeCount);
    });

    this.getUpsellBannerDismissals();

    if (this.isInitialized()) {
      const upgradeLink = document.getElementById('link-to-pricing-page');
      if (upgradeLink) {
        upgradeLink.addEventListener('click', e => {
          e.preventDefault();
          canvas.showPaymentModal();
        });
      }
    }
  }

  isInitialized() {
    return this.user && !this.canvas.store.isViewOnly() && window.pageSettings.enableNodeUpsell;
  }

  updateNodeCount(count) {
    if (!this.isInitialized()) {
      return;
    }
    if (!window.user) return;
    this.nodeCount = window.user.nodeCount;
    if (count !== undefined) {
      window.user.nodeCount = count;
      this.nodeCount = count;
    }

    localStorage.setItem(`${this.user.id}-nodeCount`, this.nodeCount);
    const progressEl = document.getElementById('node-count-progress');
    if (progressEl) {
      progressEl.style = `width: ${(this.nodeCount / FREE_CARD_LIMIT) * 100 }%;`;
    }
    const progressTextEl = document.getElementById('node-count-progress-text');
    if (progressTextEl) {
      progressTextEl.innerText = `${this.nodeCount}`;
    }

    const progressHeaderTextEl = document.getElementById('node-count-progress-header-text');
    if (progressHeaderTextEl) {
      progressHeaderTextEl.innerText = `${this.nodeCount}`;
    }

    this.maybeShowUpsellBanner();
  }


  maybeShowUpsellBanner() {
    if (!this.isInitialized()) {
      return;
    }

    if (this.isSubscriber()) {
      return;
    }

    const overWarnings = FREE_CARD_LIMIT_WARNINGS.filter(nc => this.nodeCount >= nc);

    if (overWarnings && overWarnings.length) {
      const banner = Math.max(...overWarnings);

      if (!this.dismissedUpsellBanners.includes(banner)) {
        this.upsellBannerShowing = banner;
        this.bannerTag.update();
      }
    }
  }

  showPaymentModal() {
    this.canvas.modalCheckout.show('node-limit');
  }

  dismissUpsellBanner() {
    if (!this.isInitialized()) {
      return;
    }

    const showing = this.upsellBannerShowing;
    if (showing) {
      localStorage.setItem(`${this.user.id}-bannerDismissal-${showing}`, true);
      this.getUpsellBannerDismissals();
      this.upsellBannerShowing = false;
      this.bannerTag.update();
      $.ajax({
        method: 'POST',
        url: '/api/banners/dismiss',
        data: { trigger: 'node-limit' }
      });
    }
  }

  getUpsellBannerDismissals() {
    if (!this.isInitialized()) {
      return;
    }

    for (const nodeCount of FREE_CARD_LIMIT_WARNINGS) {
      const dismissed = localStorage.getItem(`${this.user.id}-bannerDismissal-${nodeCount}`);
      if (dismissed) {
        if (!this.dismissedUpsellBanners.includes(nodeCount)) {
          this.dismissedUpsellBanners.push(nodeCount);
        }
      }
    }
  }

  isSubscriber() {
    const { user } = this;
    return user && user.active_subscription_plan && (window.subscriptionProducts[user.active_subscription_plan] || user.active_subscription_plan === 'multiseat-fixed');
  }

  subscribe(planId) {
    this.user.active_subscription_plan = planId;
    window.user.active_subscription_plan = planId;
  }

  userIsOverLimit() {
    if (!this.isInitialized()) {
      return false;
    }

    return user.nodeCount >= FREE_CARD_LIMIT && !this.isSubscriber();
  };

}

const usui = new UpsellUI({ user: window.user });

export { UpsellUI, usui };



// WEBPACK FOOTER //
// ./starling/src/lib/upsell-ui.js